<template>

  <v-app  id="inspire">

    <v-main class='bg'>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          mt-10
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >

            <v-card shaped class="elevation-12">
              <v-card-text>
                <v-form    ref="Loginform"
                v-model="Loginvalid">
                  <h2 class='ma-5'>Login to admin account</h2>
                  <v-text-field required :rules='emailRules' prepend-icon="person" name="login" v-model='userName' label="Username" type="text"></v-text-field>
                  <v-text-field required :rules='fieldRules' id="password" prepend-icon="lock" v-model='password' name="Password" label="Password" type="password" v-on:keyup.enter="login()"></v-text-field>
                  <v-btn :loading="loading" class='mt-5' :disabled="!Loginvalid" @click='login' block roundeded color="secondary">Login</v-btn>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <resetPassword text='Forgot Password?'/>
          <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import { postReq } from '../helper/firestore'
import resetPassword from '../components/resetPasswordModal'
import { mapFields } from 'vuex-map-fields';

export default {
  // apollo: {
  //   // Simple query that will update the 'hello' vue property
  //   logs: gql`query {
  //     logs {
  //       id
  //       time
  //     }
  //   }`,
  // },
  components : {
    resetPassword
  },
    data() {
      return {
        loading :false,
          fieldRules : [v => !!v || 'this field is required',],
            emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
          Loginvalid: true,
          userName : "",
          password : "",
      }
    },
    computed : {
    ...mapFields([
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
      'overlay'
    ]),
    },
mounted() {

},
methods : {
    login(){
       const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString);
        const redirect = urlParams.get('redirect')
      this.loading = true
            postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/signin', { email: this.userName, password: this.password }, result => {
              this.loading = false
              if (result.status === 200) {
                  const url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=' + process.env.VUE_APP_ROOT_API_KEY
        const options = {"email":this.userName,"password":this.password,"returnSecureToken":true}
    this.$axios
      .post(url,options)
      .then(response => {
      this.user={ name : null,
                  email : null,
                  uid : response.data.localId,
                  idToken : response.data.idToken,
                  familyHistory : []
                };
                this.loading = false
      this.isAuthorized = true ;
      // check if user has redirect param
        if(redirect === "message"){
          this.$router.push('/admin/myMessage')
        }else{
                this.$router.push('/home')
        }

      })
      .catch(()=> {
        this.loading = false
          this.snackBarType = "warning"
          this.snackBarshow =true;
          this.snackBarmessage = "Login failed, please check your user name or passowrd";
          this.isAuthorized = false
          })
              }
              else{
                  this.loading = false
                this.snackBarType = "warning"
          this.snackBarshow =true;
          this.snackBarmessage = result.data;
          this.isAuthorized = false
              }

      })

    },
}
}
</script>


<style scoped>
.bg{
background: linear-gradient(0deg, rgb(35, 40, 44) 0%, rgba(243, 246, 244, 0.979) 100%);
}

</style>
